
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogujrat() {



  const cardData =
  {
    keyword: 'Pune to Gujarat Cab Service',
    heading: 'AB Ghule Cabs: Pune to Gujarat Cab Service',
    headingDescription: 'Planning a trip from Pune to Gujarat? AB Ghule Cabs offers a reliable, comfortable, and affordable cab service for your long-distance journey to Gujarat. Whether you are traveling for business, tourism, or pilgrimage, our professional drivers and well-maintained vehicles ensure a smooth and enjoyable ride. Let us take care of your travel needs while you enjoy a seamless and safe journey to one of India’s most vibrant states.',

    top: 'Top Places to Visit in Gujarat with AB Ghule Cabs',

    "topPlaces": [
        {
          title: "Gir National Park",
          description: "Famous for being the last home of the Asiatic lions, Gir National Park is a must-visit for wildlife enthusiasts. Enjoy a thrilling safari to see these majestic creatures in their natural habitat, along with other wildlife species."
        },
        {
          title: "Somnath Temple",
          description: "A sacred pilgrimage destination, the Somnath Temple is one of the twelve Jyotirlingas of Lord Shiva. Its rich history, beautiful architecture, and spiritual significance make it a key stop for devotees."
        },
        {
          title: "Kutch Rann",
          description: "The Rann of Kutch is an expansive salt marsh that hosts the famous Rann Utsav festival. The sight of the white land under the moonlight is unforgettable, and the festival showcases Gujarat’s cultural heritage through dance, music, and crafts."
        },
        {
          title: "Dwarka",
          description: "A significant spiritual destination, Dwarka is famous for the Dwarkadhish Temple, dedicated to Lord Krishna. The town is steeped in mythology and is one of the Char Dham pilgrimage sites in India."
        },
        {
          title: "Sardar Vallabhbhai Patel Statue",
          description: "The Statue of Unity, located in the Narmada district of Gujarat, is the world’s tallest statue, honoring India’s first Deputy Prime Minister and the Iron Man of India, Sardar Patel. It’s a symbol of India’s unity and an architectural marvel."
        },
        {
          title: "Vadodara (Baroda)",
          description: "Known for its royal palaces, museums, and gardens, Vadodara is a culturally rich city in Gujarat. Visit the Laxmi Vilas Palace, Sayaji Garden, and the Baroda Museum for a dose of history and art."
        },
        {
          title: "Rishikesh Ashram",
          description: "Rishikesh Ashram in Gujarat is a peaceful retreat offering spiritual practices and meditation. It’s the perfect destination for those seeking peace and spiritual awakening."
        },
        {
          title: "Saputara",
          description: "A hill station in Gujarat, Saputara offers scenic views, lush greenery, and a peaceful environment. You can enjoy boating in Saputara Lake or explore the surrounding hills and waterfalls."
        },
        {
          title: "Champaner-Pavagadh Archaeological Park",
          description: "A UNESCO World Heritage site, this archaeological park is home to historical structures, ancient temples, and Islamic monuments. It’s an excellent destination for history buffs and architecture enthusiasts."
        },
        {
          title: "Kankaria Lake",
          description: "Located in Ahmedabad, Kankaria Lake is a popular spot for families and tourists. It offers a wide range of activities like boating, a zoo, and a balloon ride, making it a great place to spend an evening."
        }
      ],


      services: [
        {
          "name": "Pune to Surat Cab Booking",
          description: "Book your cab from Pune to Surat with AB Ghule Cabs. We offer reliable and comfortable cab services, ensuring a smooth and hassle-free journey to Surat at affordable rates."
        },
        {
          "name": "Pune to Surat Cab Price",
          description: "Check the competitive and transparent pricing for your Pune to Surat cab trip with AB Ghule Cabs. Our clear pricing structure ensures no hidden charges, making your journey cost-effective."
        },
        {
          "name": "Pune to Surat Cab",
          description: "AB Ghule Cabs provides convenient and reliable cab services for your Pune to Surat journey. Enjoy a comfortable ride with well-maintained vehicles and experienced drivers ensuring a safe trip."
        },
        {
          "name": "Pune to Surat Taxi Cab Hire",
          description: "Hire a taxi from Pune to Surat with AB Ghule Cabs. We offer a range of well-maintained vehicles, ensuring that your ride is comfortable, safe, and affordable."
        },
        {
          "name": "Pune to Gujarat Cab Booking",
          description: "Book a cab from Pune to Gujarat with AB Ghule Cabs. We provide reliable and affordable cab services for a comfortable journey to any city in Gujarat, tailored to your travel needs."
        },
        {
          "name": "Pune to Ahmedabad Cab",
          description: "Travel from Pune to Ahmedabad with AB Ghule Cabs. We offer comfortable, reliable, and affordable cab services, ensuring a smooth ride from Pune to Ahmedabad."
        },
        {
          "name": "Pune to Vadodara Cab",
          description: "AB Ghule Cabs offers reliable Pune to Vadodara cab services. Our well-maintained vehicles and experienced drivers ensure you travel safely and comfortably, whether it’s for a one-way or round trip."
        },
        {
          "name": "Pune to Rajkot Cab Service",
          description: "For a comfortable and affordable cab service from Pune to Rajkot, AB Ghule Cabs is your trusted option. We provide reliable and timely services with experienced drivers for a safe journey."
        },
        {
          "name": "Pune to Gujarat Round Trip Cab Service",
          description: "AB Ghule Cabs provides round-trip cab services from Pune to Gujarat. Whether you are traveling to Ahmedabad, Surat, Vadodara, or other cities, we ensure a comfortable and hassle-free round-trip experience."
        },
        {
          "name": "Pune to Pavagadh Taxi Service",
          description: "Book a taxi from Pune to Pavagadh with AB Ghule Cabs. Our taxi service ensures a comfortable journey to this historic location, with well-maintained vehicles and professional drivers."
        },
        {
          "name": "Pune to Gandhinagar Gujarat Taxi Service",
          description: "AB Ghule Cabs offers taxi services from Pune to Gandhinagar, Gujarat. Our experienced drivers and well-maintained vehicles provide a safe, timely, and comfortable trip to Gandhinagar."
        },
        {
          "name": "Pune to Somnath Trip with AB Ghule Cabs",
          description: "For your Pune to Somnath trip, AB Ghule Cabs offers reliable and comfortable taxi services. Our professional drivers ensure you have a smooth and enjoyable journey to Somnath."
        },
        {
          "name": "Pune to Bhavnagar Cab Service",
          description: "AB Ghule Cabs offers Pune to Bhavnagar cab services. Whether it's a one-way trip or a round trip, our experienced drivers and comfortable vehicles ensure a safe and smooth journey."
        },
        {
          "name": "Pune Vadodara Cab Booking",
          description: "Book your cab from Pune to Vadodara with AB Ghule Cabs. Our affordable and reliable cab services ensure a smooth and timely journey, making your travel to Vadodara convenient and comfortable."
        },
        {
          "name": "Pune to Gujarat Tempo Traveller on Rent",
          description: "AB Ghule Cabs provides Tempo Traveller rentals for your Pune to Gujarat trip. Ideal for group travel, our well-maintained Tempo Travellers ensure a comfortable journey for all passengers."
        },
        {
          "name": "Pune to Rajkot Cab",
          description: "For your Pune to Rajkot trip, AB Ghule Cabs offers comfortable and reliable cab services. Our experienced drivers and well-maintained vehicles ensure a safe and pleasant ride."
        },
        {
          "name": "Pune to Statue of Unity on Statue Cabs",
          description: "Travel to the Statue of Unity from Pune with AB Ghule Cabs. Our Statue Cabs service ensures a comfortable and memorable journey to one of the world's tallest statues, with reliable drivers and well-maintained vehicles."
        },
        {
          "name": "Pune to Gujarat Cab Service",
          description: "AB Ghule Cabs offers affordable and reliable cab services from Pune to Gujarat. Whether you're traveling to Ahmedabad, Surat, Vadodara, or any other city, our services ensure a smooth and comfortable journey."
        },
        {
          "name": "Pune to Gujarat Cab Service Contact Number",
          description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Pune to Gujarat Cab Service. We ensure a smooth and enjoyable ride for all our customers. Whether it's a short or long trip, we are always ready to assist."
        }
      ],

      tableData: [
        ["Pune to Surat Cab Booking", "-Pune to Surat Cab Price"],
        ["Pune to Surat Cab", "-Pune to Surat Taxi Cab Hire"],
        ["Pune to Gujarat Cab Booking", "-Pune to Ahmedabad Cab"],
        ["Pune to Vadodara Cab", "-Pune to Rajkot Cab Service"],
        ["Pune to Gujarat Round Trip Cab Service", "-Pune to Pavagadh Taxi Service"],
        ["Pune to Gandhinagar Gujarat Taxi Service", "-Pune to Somnath Trip with AB Ghule Cabs"],
        ["Pune to Bhavnagar Cab Service", "-Pune Vadodara Cab Booking"],
        ["Pune to Gujarat Tempo Traveller on Rent", "-Pune to Rajkot Cab"],
        ["Pune to Statue of Unity on Statue Cabs", "-Pune to Gujarat Cab Service"]
      ],
      
      whychoose: [
        {
          WhyChooseheading: "Reliable and Professional Service",
          WhyChoosedescription: "AB Ghule Cabs offers reliable and professional Pune to Gujarat cab services. Our drivers are highly skilled, courteous, and committed to ensuring a safe and comfortable journey from Pune to various destinations in Gujarat."
        },
        {
          WhyChooseheading: "24/7 Availability",
          WhyChoosedescription: "We understand that travel plans can vary, so we provide 24/7 availability for your Pune to Gujarat trip. Whether you're planning an early morning departure or a late-night journey, we are ready to assist you at any time."
        },
        {
          WhyChooseheading: "Affordable Rates",
          WhyChoosedescription: "We offer competitive, transparent pricing with no hidden fees. Our fare structure is designed to provide great value, whether you are traveling alone or with a group, ensuring that your trip is both affordable and comfortable."
        },
        {
          WhyChooseheading: "Clean and Well-Maintained Fleet",
          WhyChoosedescription: "Our fleet includes a variety of vehicles, from standard sedans to luxury options, all maintained to the highest standards. Each vehicle is regularly cleaned and checked for safety and comfort, ensuring a smooth and pleasant ride on your journey to Gujarat."
        },
        {
          WhyChooseheading: "Safe and Comfortable Rides",
          WhyChoosedescription: "Your safety is our top priority. Our drivers are experienced and background-checked, and our vehicles are equipped with GPS and other safety features to ensure a secure journey on your Pune to Gujarat route."
        },
        {
          WhyChooseheading: "Easy Booking Process",
          WhyChoosedescription: "Booking your cab for a Pune to Gujarat trip is simple and quick. You can book your ride online via our website, through our mobile app, or by calling our customer service team for immediate assistance."
        },
        {
          WhyChooseheading: "Customer Satisfaction",
          WhyChoosedescription: "We pride ourselves on customer satisfaction. With numerous positive reviews and repeat customers, we are dedicated to making your Pune to Gujarat trip a memorable and comfortable experience."
        }
      ]
      
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a Pune to Gujarat cab with AB Ghule Cabs?',
      answer: 'You can book your cab easily through our website, mobile app, or by calling our customer service team for assistance.',
    },
    {
      id: 'FAQ2',
      question: 'Are your drivers experienced and trustworthy?',
      answer: 'Yes, all of our drivers are well-trained, experienced, and background-checked to ensure a safe and pleasant journey.',
    },
    {
      id: 'FAQ3',
      question: 'What types of vehicles are available for booking?',
      answer: 'We offer a wide range of vehicles, including sedans, SUVs, and luxury cars, to cater to different needs and preferences for your Pune to Gujarat trip.',
    },
    {
      id: 'FAQ4',
      question: 'How do I pay for my ride?',
      answer: 'You can pay for your ride through cash, credit/debit cards, or online payment via our mobile app, offering you multiple flexible payment options.',
    },
    {
      id: 'FAQ5',
      question: 'Are there any additional charges for waiting or detours?',
      answer: 'Additional charges may apply for waiting time or detours, depending on the nature of your trip. We ensure transparency in our pricing, and any extra charges will be communicated to you in advance.',
    },
    {
      id: 'FAQ6',
      question: 'Can I cancel or modify my booking?',
      answer: 'Yes, you can easily modify or cancel your booking through our website or app. Our customer service team is also available to assist with any changes.',
    },
    {
      id: 'FAQ7',
      question: 'Do you offer one-way and round-trip services?',
      answer: 'Yes, we offer both one-way and round-trip services for your Pune to Gujarat journey, so you can choose the most convenient option based on your travel plans.',
    },
    {
      id: 'FAQ8',
      question: 'Is AB Ghule Cabs available for group travel?',
      answer: 'Yes, we have spacious vehicles available for group travel, ensuring that your family, friends, or colleagues can travel comfortably together on your trip to Gujarat.',
    },
    {
      id: 'FAQ9',
      question: 'What makes AB Ghule Cabs different from other cab services?',
      answer: 'AB Ghule Cabs is known for its reliable, professional service, experienced drivers, transparent pricing, and a wide range of vehicle options. We prioritize your safety, comfort, and satisfaction on every journey.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: "Mr. Raghav Desai",
      feedback: "I recently took a trip from Pune to Gujarat with AB Ghule Cabs, and the service was excellent. The driver was professional, the car was comfortable, and the trip was smooth and enjoyable. Highly recommend for anyone traveling to Gujarat!",
      rating: 5,
    },
    {
      id: 2,
      name: "Ms. Swati Sharma",
      feedback: "My family and I traveled to Gujarat from Pune using AB Ghule Cabs. The booking process was simple, the vehicle was spacious, and the driver was courteous and knowledgeable. It was a pleasant journey, and we will definitely use their service again.",
      rating: 5,
    },
  ];
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Gujarat Cab Service | Reliable & Affordable Cabs</title>
  <meta name="description" content="Book reliable and affordable cab services from Pune to Gujarat, including Surat, Ahmedabad, Vadodara, Rajkot, and more. Call +91 8624029699 for bookings with AB Ghule Cabs." />
  <meta name="keywords" content="Pune to Surat Cab Booking, Pune to Surat Cab Price, Pune to Surat Taxi Cab Hire, Pune to Gujarat Cab Booking, Pune to Ahmedabad Cab, Pune to Vadodara Cab, Pune to Rajkot Cab Service, Pune to Gujarat Round Trip Cab Service, Pune to Pavagadh Taxi Service, Pune to Gandhinagar Gujarat Taxi Service, Pune to Somnath Trip, Pune to Bhavnagar Cab Service, Pune Vadodara Cab Booking, Pune to Gujarat Tempo Traveller on Rent, Pune to Rajkot Cab, Pune to Statue of Unity on Statue Cabs" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Gujarat Cab Service | Reliable & Affordable Cabs" />
  <meta property="og:description" content="Book reliable and affordable cab services from Pune to Gujarat, including Surat, Ahmedabad, Vadodara, Rajkot, and more. Call +91 8624029699 for bookings with AB Ghule Cabs." />
  <meta property="og:image" content="https://abghulecabs.com/images/pune-to-gujarat-cab-service.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/pune-to-gujarat-cab-service" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Pune to Gujarat Cab Service",
        description: "Book reliable and affordable cab services from Pune to Gujarat, including Surat, Ahmedabad, Vadodara, Rajkot, and more. Call +91 8624029699 for bookings with AB Ghule Cabs.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/pune-to-gujarat-cab-service",
        "logo": "https://abghulecabs.com/images/pune-to-gujarat-cab-service.jpg",
        "image": "https://abghulecabs.com/images/pune-to-gujarat-cab-service.jpg",
        "priceRange": "₹2500 - ₹10000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/pune-to-gujarat-cab-service",
          "priceCurrency": "INR",
          "price": "2500",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "120"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Amit R"
            },
            "datePublished": "2024-09-15",
            "reviewBody": "The service was excellent. The driver was friendly and ensured a safe and comfortable ride. Will definitely recommend for all Gujarat trips."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Priya M"
            },
            "datePublished": "2024-08-10",
            "reviewBody": "Great experience! The trip from Pune to Surat was smooth and hassle-free. Highly recommended for anyone traveling to Gujarat."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune to Gujarat Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/pune-to-gujarat-cab-service"
        },
        "keywords": "Pune to Surat Cab Booking, Pune to Surat Cab Price, Pune to Surat Taxi Cab Hire, Pune to Gujarat Cab Booking, Pune to Ahmedabad Cab, Pune to Vadodara Cab, Pune to Rajkot Cab Service, Pune to Gujarat Round Trip Cab Service, Pune to Pavagadh Taxi Service, Pune to Gandhinagar Gujarat Taxi Service, Pune to Somnath Trip, Pune to Bhavnagar Cab Service, Pune Vadodara Cab Booking, Pune to Gujarat Tempo Traveller on Rent, Pune to Rajkot Cab, Pune to Statue of Unity on Statue Cabs"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/62.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetogujrat;